export const environment = {
  production: false,
  baseUrl: 'https://lor.upnow.com/api',
  oauthUrl: 'https://lor.upnow.com/oauth/v2',
  oauthClientId: '7a9d8015193702ca8f57ca6d0e5da513bad46e9c5713a503be02ee9e782ce96e',
  oauthClientSecret: '023ac6ea776d8abed9f60d06079dfa62751559c2280c3a9e1ab9114194e772c4'
};
